import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import ILC_Table from "./ilc_table/ILC_Table";
import ILC_Filter from "./ilc_filter/ILC_Filter";
import { useDispatch, useSelector } from "react-redux";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const ILC = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
    const haveReportPermission = permissions?.includes(
      FixIDS.ilc_report.Report,
    );
 
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <ILC_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <ILC_Table
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>
    
    </section>
  );
};

export default ILC;
